import * as React from "react"

import { cn } from "@/lib/utils"

// 높이는 놓이는 자리가 정한다: default 36px(폼) · sm 32px(제목·필터 줄) · xs 28px(조밀 패널·표 칸)
const inputSize = {
  default: "",
  sm: "h-8",
  xs: "h-7 px-2",
} as const

type InputSize = keyof typeof inputSize

function Input({
  className,
  type,
  size = "default",
  ...props
}: Omit<React.ComponentProps<"input">, "size"> & { size?: InputSize }) {
  return (
    <input
      type={type}
      data-slot="input"
      data-size={size}
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        inputSize[size],
        className
      )}
      {...props}
    />
  )
}

export { Input, type InputSize }
